/* eslint-disable @angular-eslint/no-input-rename */
import { SelectionModel } from '@angular/cdk/collections';
import {
  AfterContentInit,
  Directive,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatChipGrid, MatChipInput, MatChipRow } from '@angular/material/chips';
import { isArray } from 'lodash';
import { merge, startWith, Subject, switchMap, takeUntil, tap } from 'rxjs';

@Directive({
    selector: '[luiChipsAutocomplete]',
    standalone: false
})
export class ChipsAutocompleteDirective
  implements OnInit, AfterContentInit, OnDestroy
{
  @Input('matChipInputFor') matChipGrid!: MatChipGrid;
  @Input() matAutocomplete!: MatAutocomplete;

  selection = new SelectionModel(true);

  control!: FormControl;

  _destroy = new Subject<void>();

  constructor(private chipInput: MatChipInput) {}

  ngOnInit(): void {
    const control = this.matChipGrid.ngControl.control;

    this.matAutocomplete.optionSelected
      .asObservable()
      .pipe(takeUntil(this._destroy))
      .subscribe((e: MatAutocompleteSelectedEvent) => {
        this.selection.select(e.option.value);

        this.chipInput.clear();
      });

    this.selection.changed
      .asObservable()
      .pipe(takeUntil(this._destroy))
      .subscribe(() => {
        if (control && control instanceof FormControl) {
          this.control = control;

          this.control.setValue(this.selection.selected);
        }
      });

    if (control && control.value) {
      const value = control.value;

      if (isArray(value)) {
        this.selection.select(...control.value);
      } else {
        this.selection.select(control.value);
      }
    }
  }

  ngAfterContentInit(): void {
    this.matChipGrid._chips.changes
      .pipe(
        startWith(this.matChipGrid._chips),
        switchMap((ql: QueryList<MatChipRow>) =>
          merge(...ql.map((chipRow) => chipRow.removed))
        ),
        takeUntil(this._destroy)
      )
      .subscribe((x) => {
        this.selection.deselect(x.chip.value);
      });
  }

  ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
  }
}
